@use '@/styles/variables' as *;

.bottomButtonsBlockWrapper {
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 100%;
    z-index: $zIndexElements;

    &.absolute {
        position: absolute;
    }

    &.static {
        position: static;
    }
}
